import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { organisationsListEpFactory } from './endpoints';

export const organisationsApi = createApi({
  reducerPath: 'organisationsApi',
  baseQuery: fetchBaseQuery({ baseUrl: `http://localhost:7000` }),
  endpoints: (builder) => ({
    getOrganisationsList: organisationsListEpFactory(builder),
  }),
});

export const {
  useGetOrganisationsListQuery,
  useLazyGetOrganisationsListQuery,
} = organisationsApi;
